<template>
  <div class="info__intro">
    <section class="intro__item intro__item--padding">
      <p data-anim-in="text">#OWOF</p>
      <h3 class="intro__title" data-anim-in="title">{{ data.title }}</h3>
      <div class="intro__subtitle">
        <p
          v-for="paragraph in data.subtitle"
          :key="paragraph"
          v-html="paragraph"
          data-anim-in="text"
        >
          {{ paragraph }}
        </p>
      </div>

      <div class="intro__content">
        <p
          v-for="paragraph in data.content"
          :key="paragraph"
          v-html="paragraph"
          data-anim="text"
        >
          {{ paragraph }}
        </p>
      </div>
    </section>

    <section class="intro__item intro__item--image" data-parallaxin="relative" style="transform: matrix(1, 0, 0, 1, 0, 53);">
      <figure>
        <img v-lazy="switchImg" :alt="data.image.alt">
        <div class="intro__image" v-lazy:background-image="switchImg"></div>
      </figure>
      <Social class="social__wrapper--desktop"/>
    </section>
  </div>
</template>

<script>
import gsap from 'gsap';
import router from '@/router';
import Eventer from 'eventer-js';

import Social from '@/components/Social';
import animations from '@/scripts/animations';


export default {
  name: 'InfoIntro',

  props: ['data'],

  components: {
    Social,
  },

  mounted() {
    const animIn = Array.from(this.$el.querySelectorAll('[data-anim-in]'));
    gsap.set(animIn, { autoAlpha: 0 });

    setTimeout(() => {
      animIn.forEach((element) => {
        const type = element.getAttribute('data-anim-in');

        animations.get(type)(element);
      });
    }, 1000);

    this.eventer = new Eventer(true);
    this.links = Array.from(this.$el.querySelectorAll('[data-customlink]'));

    if (this.links.length > 0) {
      this.links.forEach((link) => {
        this.eventer.bindEvent('click', link, this.handleClick);
      });
    }
  },

  computed: {
    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.data.image.src}.webp`;
      }
      return `${this.data.image.src}.jpg`;
    },
  },

  methods: {
    handleClick() {
      event.preventDefault();
      const url = event.target.getAttribute('href');

      router.push(url);
    },
  },

  beforeDestroy() {
    if (this.links.length > 0) {
      this.links.forEach((link) => {
        this.eventer.clearAll(link);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';


.info__intro {
  position: relative;
  padding: 30vh 0 80px 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @include mq(sm) {
    padding: 30vh 0 100px 0;
  }

  .intro__item--image {
    position: absolute;
    z-index: 0;

    @include mq(sm) {
      position: relative;
    }
  }

  figure {
    position: relative;
    width: 65%;
    margin: 0 0 0 auto;
    padding: 0;

    overflow: hidden;

    @include aspect-ratio(5, 9);

    @include mq(sm) {
      width: calc(100% + 40px);
      margin: 0;

      @include aspect-ratio(5, 7);
    }

    img {
      @include visually-hidden;
    }

    div {
      transform: scale(1.5);
      opacity: 0.5;

      @include mq(sm) {
        opacity: 1;
      }
    }

    div[lazy="loaded"] {
      transform: scale(1);
    }
  }

  [data-anim-in] {
    position: relative;
  }

  .intro__item {
    width: 100%;

    @include mq(sm) {
      width: calc(50% - 40px);
    }

    &--padding {
      padding: 0 40px 0 40px;

      @include mq(sm) {
        padding: 0 0 0 100px;
      }
    }

    > p {
      padding-bottom: 40px;
      font-weight: 500;
    }
  }
  .social__wrapper--desktop {
    display: none;

    @include mq(sm) {
      display: block;
    }
  }

  .intro__title {
    line-height: 1.45;
    font-size: 2.1875rem;
    color: transparent;
    -webkit-text-stroke: 1px $color-light;
  }

  .intro__subtitle {
    margin: 120px 0 80px 0;
    color: $color-light;
    font-weight: 500;
  }

  .intro__content p {
    position: relative;
    margin-top: 40px;
    color: $color-gray;
  }

  .intro__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoIntro.vue